
"use client";

import React from "react";
import Image from "next/image";
import Link from "next/link";

const Footer: React.FC = () => {
  return (
    <>
      {/* Footer Area */}
      <footer className="footer-area">
        <div className="container">
          <div className="row">
            {/* Footer Left */}
            <div className="col-lg-3 col-md-6">
              <div className="footer-left">
                <Link href="/" className="logo">
                  <Image src="/images/cayman_acadmy_footer_logo.svg" alt="Cayman Academy Logo" width={200} height={60} />
                </Link>
                <p>
                  Cayman Academy provides quality, faith-centered education that builds excellence, values, and lifelong skills.
                </p>
                <ul className="footer-social">
                  <li>
                    <a href="https://www.facebook.com/caymanacademy/" target="_blank" rel="noopener noreferrer">
                      <i className="fa-brands fa-facebook-f"></i>
                    </a>
                  </li>
                  <li>
                    <a href="https://www.instagram.com/caymanacademy/" target="_blank" rel="noopener noreferrer">
                      <i className="fa-brands fa-instagram"></i>

                      {/* <i className="fa-brands fa-twitter"></i> */}
                    </a>
                  </li>
                  {/* <li>
                    <Link href="/contact">
                      <i className="fa-solid fa-envelope"></i>
                    </Link>
                  </li> */}
                  {/* <li>
                    <a href="https://www.google.com/" target="_blank" rel="noopener noreferrer">
                      <i className="fa-brands fa-google-plus-g"></i>
                    </a>
                  </li> */}
                </ul>
              </div>
            </div>

            {/* Footer School Links */}
            <div className="col-lg-2 col-md-6">
              <div className="footer-content fml-25">
                <h2>School</h2>
                <ul>
                  <li>
                    <Link href="/about/welcome">
                      <i className="flaticon-next"></i> About Us
                    </Link>
                  </li>
                  <li>
                    <Link href="/teachers">
                      <i className="flaticon-next"></i> Our Teachers
                    </Link>
                  </li>
                  <li>
                    <Link href="/school/extraCurricular">
                      <i className="flaticon-next"></i> School Life
                    </Link>
                  </li>
                  <li>
                    <Link href="/career">
                      <i className="flaticon-next"></i> Careers
                    </Link>
                  </li>
                  <li>
                    <Link href="/contact">
                      <i className="flaticon-next"></i> Contact Us
                    </Link>
                  </li>
                </ul>
              </div>
            </div>

            {/* Footer Quick Links */}
            <div className="col-lg-2 col-md-6">
              <div className="footer-content fml-15">
                <h2>Quick Links</h2>
                <ul>
                  <li>
                    <Link href="/">
                      <i className="flaticon-next"></i> Home
                    </Link>
                  </li>
                  <li>
                    <Link href="/admission">
                      <i className="flaticon-next"></i> Admissions
                    </Link>
                  </li>
                  <li>
                    <Link href="/event">
                      <i className="flaticon-next"></i> Events
                    </Link>
                  </li>
                  <li>
                    <Link href="/#">
                      <i className="flaticon-next"></i> Admission Policy
                    </Link>
                  </li>
                  {/* <li>
                    <Link href="/faq">
                      <i className="flaticon-next"></i> FAQ
                    </Link>
                  </li> */}
                </ul>
              </div>
            </div>

            {/* Footer Contact */}
            <div className="col-lg-2 col-md-6">
              <div className="footer-content footer-contact">
                <h2>Find Us</h2>
                <ul>
                  <li>
                    <a href="tel:+13456402642">
                      <i className="flaticon-next"></i>+1 (345) 640-2642
                    </a>
                  </li>
                  <li>
                    <a href="tel:+13456402643">
                      <i className="flaticon-next"></i>+1 (345) 640-2643
                    </a>
                  </li>
                  <li>
                    <a href="tel:+13456402644">
                      <i className="flaticon-next"></i>+1 (345) 640-2644
                    </a>
                  </li>
                  {/* <li>
                    <a href="mailto:office.secretary@caymanacdemy.ky">
                      <i className="flaticon-next"></i>office.secretary@caymanacdemy.ky 
                    </a>
                  </li> */}
                  {/* <li>
                    <a href="mailto:support@caymanacademy.com">
                      <i className="flaticon-next"></i> support@caymanacademy.com
                    </a>
                  </li> */}
                  <li>
                    <a href="#">
                      <i className="flaticon-next"></i> 211 Walkers Road, George Town, <br /> Cayman Island. KY1-1106
                    </a>
                  </li>
                </ul>
              </div>
            </div>

            {/* Google Map */}
            <div className="col-lg-3 col-md-6">
              <div className="footer-content fml-15">
                <h2>Location</h2>
                <div className="footer-map" style={{ width: "100%", height: "200px", borderRadius: "8px", overflow: "hidden" }}>
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d531.6746978650566!2d-81.38539974418909!3d19.28719924504945!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8f258689fab1101b%3A0xc1a52cf3c14ea07b!2sCayman%20Academy!5e1!3m2!1sen!2suk!4v1774960477668!5m2!1sen!2suk%22" width="100%"
                    height="100%"
                    style={{ border: 0 }}
                    allowFullScreen
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                  ></iframe>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>

      {/* Copy Area */}
      <div className="copy-area">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="copy">
                <p>
                  © <span>All Rights</span> by{" "}
                  <a href="https://caymanacademy.ky/" target="_self" rel="noopener noreferrer">
                    Cayman Academy
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer;
